import {defineSlotRecipe} from '@chakra-ui/react3'

export const buttonGroupSlotRecipe = defineSlotRecipe({
    slots: ['container'],
    base: {
        container: {
            display: 'flex',
            flexDirection: 'row',
            flexWrap: {base: 'wrap', s: 'nowrap'}, // wrap only on mobile
            gap: 3,
            // default children size
            '& > *': {
                flex: '0 1 auto' // size to content
            }
        }
    },
    variants: {
        orientation: {
            vertical: {
                container: {
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                    alignItems: 'flex-start'
                }
            },
            horizontal: {
                container: {
                    // wrap detected - make buttons full width
                    '&[data-wrapped=true] > *': {
                        flex: '1 1 max-content'
                    }
                }
            }
        },
        canWrap: {
            true: {
                container: {
                    flexWrap: 'wrap',
                    '&[data-wrapped=true] > *': {
                        flex: '0 1 auto' // size to content
                    }
                }
            },
            false: {}
        }
    },
    defaultVariants: {
        orientation: 'horizontal',
        canWrap: false
    }
})
